var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[_c('v-card',{class:_vm.classname,attrs:{"flat":"","tile":"","min-height":_vm.minHeight,"color":_vm.bgcolor}},[_c('v-container',{},[_c('div',{attrs:{"id":_vm.storeKey}})])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }